import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import {
  requestOrganization,
  storeOrganization,
} from "../../../redux/Actions/organizations.actions";
import {requestJob, saveJob} from "../../../redux/Actions/jobs.action";
import {getOrganization} from "../../../redux/Selectors/organization.selector";
import SafeView from "../../../components/safeView/SafeView";
import ProtectedContent from "../../../components/ProtectedContent";

const OrganizationDetails = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const organization = useSelector(getOrganization);
  const {configuration = {}, task_id} = organization;
  const {user = {}, address = {}} = configuration;
  const {billing = {}, mailing = {}, shipping = {}} = address;

  useEffect(() => {
    dispatch(requestOrganization(params.id));

    return () => {
      dispatch(storeOrganization({}));
    };
  }, [dispatch, params.id]);

  useEffect(() => {
    if (task_id) {
      dispatch(requestJob(task_id));
    }

    return () => {
      dispatch(saveJob({}));
    };
  }, [dispatch, task_id]);

  return (
    <SafeView>
      <ProtectedContent perms={["change_organization"]} showFallback>
        <div style={{marginTop: "32px"}}>
          <Row>
            <Col xs="12" sm="12" md="6" lg="4" xl="3">
              <Card className="mb-2 ml--2 ml-md-0">
                <CardHeader>
                  <CardTitle tag={"h2"} style={{marginBottom: 0}}>
                    Owner Details
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row className="mb-2">
                    <Col xs={"4"}>
                      <b>Name</b>
                    </Col>
                    <Col>{`${user.first_name} ${user.last_name}`}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={"4"}>
                      <b>Username</b>
                    </Col>
                    <Col data-cy={"username"}>{user.username}</Col>
                  </Row>
                  <Row className="mb-2" data-cy={"email"}>
                    <Col xs={"4"}>
                      <b>Email</b>
                    </Col>
                    <Col>{user.email}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={"4"}>
                      <b>Privacy</b>
                    </Col>
                    <Col>{configuration.privacy_policy_url}</Col>
                  </Row>
                  <Row>
                    <Col xs={"4"}>
                      <b>Website</b>
                    </Col>
                    <Col>{configuration.website_url}</Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" sm="12" md="6" lg="4" xl="3">
              <Card className="mb-2">
                <CardHeader>
                  <CardTitle tag={"h2"} style={{marginBottom: 0}}>
                    Billing Address
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>{billing.street_address1},</Row>
                  <Row>{`${billing.city}, ${billing.state},`}</Row>
                  <Row>{`${billing.country} - ${billing.zip_code}`}</Row>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" sm="12" md="6" lg="4" xl="3">
              <Card className="mb-2">
                <CardHeader>
                  <CardTitle tag={"h2"} style={{marginBottom: 0}}>
                    Shipping Address
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>{shipping.street_address1},</Row>
                  <Row>{`${shipping.city}, ${shipping.state},`}</Row>
                  <Row>{`${shipping.country} - ${shipping.zip_code}`}</Row>
                </CardBody>
              </Card>
            </Col>
            <Col xs="12" sm="12" md="6" lg="4" xl="3">
              <Card className="mb-2">
                <CardHeader>
                  <CardTitle tag={"h2"} style={{marginBottom: 0}}>
                    Mailing Address
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>{mailing.street_address1},</Row>
                  <Row>{`${mailing.city}, ${mailing.state},`}</Row>
                  <Row>{`${mailing.country} - ${mailing.zip_code}`}</Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </ProtectedContent>
    </SafeView>
  );
};

export default OrganizationDetails;
